
export default class ReceiptLinePallet {
    constructor(id, qty){
        this.glasschainId = id || "";
        this.unitQty = qty || 0;


    }
}